
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getWaterBucketUsePage } from '@/api/record'
import UserNameRemark from '@/components/UserNameRemark/index.vue'
import { UserModule } from '@/store/modules/user'

@Component({ name: 'WaterBucketUseLog', components: { UserNameRemark } })
export default class extends Vue {
  private loading = false
  private list: any[] = []
  private total = 0
  private query = { pageNum: 1, pageSize: 10, userPhone: '', orderNumber: '' }

  get currentStoreId() {
    const sid = UserModule.storeId
    if (!sid) return null
    const n = Number(sid)
    return Number.isNaN(n) ? null : n
  }

  @Watch('currentStoreId')
  private onStoreChange() {
    this.query.pageNum = 1
    this.loadList()
  }

  mounted() { this.loadList() }

  private packageLabel(row: any) {
    if (!row) return '—'
    if (row.packageName) return row.packageName
    const typeName = row.quotaTypeName || ''
    const dish = row.dishName || ''
    if (typeName && dish) return `${typeName} · ${dish}`
    return typeName || dish || '—'
  }

  private usedLabel(row: any) {
    if (row == null || row.usedBuckets == null) return '—'
    return `${row.usedBuckets} 桶`
  }

  private remainingLabel(row: any) {
    if (row == null || row.remainingBuckets == null) return '—'
    return `${row.remainingBuckets} 桶`
  }

  private async loadList() {
    if (this.currentStoreId == null) {
      this.list = []
      this.total = 0
      return
    }
    this.loading = true
    try {
      const params: any = {
        pageNum: this.query.pageNum,
        pageSize: this.query.pageSize,
        storeId: this.currentStoreId,
      }
      if (this.query.userPhone) params.userPhone = this.query.userPhone.trim()
      if (this.query.orderNumber) params.orderNumber = this.query.orderNumber.trim()
      const res: any = await getWaterBucketUsePage(params)
      if (String(res.data.code) === '1' && res.data.data) {
        this.list = res.data.data.records || []
        this.total = res.data.data.total || 0
      } else {
        this.list = []
        this.total = 0
      }
    } finally {
      this.loading = false
    }
  }

  private handleSearch() { this.query.pageNum = 1; this.loadList() }
  private handleReset() {
    this.query = { pageNum: 1, pageSize: 10, userPhone: '', orderNumber: '' }
    this.loadList()
  }
}
